// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { ProposalSource } from './proposalSource.zod.ts';

export const ProposedMetric = zod.object({
  "after": zod.union([zod.string(),zod.null()]),
  "before": zod.union([zod.string(),zod.null()]),
  "label": zod.string(),
  "provenance": zod.enum(['client_measured', 'self_measured', 'expected']),
  "source": ProposalSource,
  "unit": zod.union([zod.string(),zod.null()]),
  "value": zod.union([zod.string(),zod.null()])
});

export type ProposedMetric = zod.input<typeof ProposedMetric>;
export type ProposedMetricOutput = zod.output<typeof ProposedMetric>;
